import approvals from '../modules/approvals/lang/es'
// Ready translated locale messages
export default {
  ...approvals,
  general: {
    adminPanel: 'Panel administración',
    configGeneral: 'Configuración general',
    helpCenter: 'Centro de ayuda',
    userPanel: 'Panel usuario',
    others: 'Otros',
    required: 'Datos requeridos',
    requestStatus: {
      created: 'Creado',
      sent: 'Enviado',
      in_review: 'En validación',
      approved: 'Aprobado',
      rejected: 'Rechazado'
    },
    settingDelete: 'Ajuste eliminado exitosamente',
    period: 'Periodo',
    copy: 'Copiar',
    category: 'Categoría',
    concepts: 'Conceptos',
    amountRequest: 'Monto Anticipo',
    requestBy: 'Solicitado por',
    validateRequest: 'Validar solicitud',
    validateRequestPettyCash: 'Validar solicitud caja chica',
    validateExpenses: 'Validar gastos',
    expenseReport: 'Reporte de gasto',
    vehicle: 'Vehículo',
    licensePlate: 'Placa',
    initialMileage: 'Kilometraje inicial',
    litersOfGasoline: 'Litros de gasolina',
    finalLitersOfGasoline: 'Litros de gasolina final',
    finalMileage: 'Kilometraje final',
    orderNumber: 'Número de orden',
    home: 'Inicio',
    dashboard: 'Tablero',
    userOptions: 'Opciones de Usuario',
    reportsOptions: 'Opciones de Reportes',
    reportsType: 'Gastos acumulados por categoría',
    companyOptions: 'Opciones de empresa',
    expenseOptions: 'Opciones de Gastos',
    users: 'Usuarios',
    userApplication: 'Usuarios de aplicaciones',
    application: 'Aplicación',
    categories: 'Categorías',
    areas: 'Áreas',
    settings: 'Ajustes',
    validators: 'Validadores',
    approver: 'Aprobador',
    companies: 'Empresas',
    company: 'Empresa',
    restrictions: 'Restricciones',
    projects: 'Proyectos',
    branches: 'Sucursales',
    allBranches: 'Todas las sucursales',
    roles: 'Roles',
    expenses: 'Comprobaciones',
    expenseStatus: 'Estatus del gasto',
    expenseItems: 'Gastos',
    workflow: 'Flujo de Trabajo',
    permissions: 'Permisos',
    substitutes: 'Sustitutos',
    subscriptions: 'Suscripciones',
    history: 'Historial',
    notifications: 'Notificaciones',
    rejected: 'Gastos Rechazados',
    approbed: 'Gastos Aprobados',
    validate: 'Validar Gastos',
    approbe: 'Aprobar Gastos',
    check: 'Aprobaciones',
    keywords: 'Palabras clave',
    payable: 'Gastos por Pagar',
    advances: 'Anticipos',
    logout: 'Cerrar sesión',
    edit: 'Editar',
    delete: 'Eliminar',
    activate: 'Activar',
    activeValidator: 'Validador activo',
    inactiveValidator: 'Validador inactivo',
    deactivate: 'Desactivar',
    cancel: 'Cancelar',
    submit: 'Enviar',
    save: 'Guardar',
    saveChanges: 'Guardar cambios',
    reset: 'Restablecer',
    name: 'Nombre',
    user: 'Usuario',
    startDate: 'Fecha inicial',
    endDate: 'Fecha final',
    selectEndDate: 'Escoger una fecha final',
    project: 'Proyecto',
    projectSecond: 'Proyectos secundarios',
    supplier: 'Proveedor',
    status: 'Estado',
    description: 'Descripción',
    date: 'Fecha',
    country: 'País',
    currency: 'Moneda',
    exchangeRate: 'TC',
    subtotal: 'Subtotal',
    total: 'Total',
    totalAmountMXN: 'Monto total MXN',
    totalMXN: 'Total MXN',
    amount: 'Monto',
    amountMXN: 'Monto MXN',
    formaPago: 'Forma de pago',
    metodoPago: 'Método de pago',
    folioRef: 'Folio / Número de referencia',
    folioReference: 'Folio / Referencia',
    comment: 'Comentario',
    receiptType: 'Tipo de comprobante',
    expenseType: 'Tipo de comprobación',
    email: 'Correo electrónico',
    uuid: 'UUID',
    isRefund: '¿Es reembolso?',
    actions: 'Acciones',
    deleteElement: 'Eliminar elemento',
    activateElement: 'Activar elemento',
    deactivateElement: 'Desactivar elemento',
    deleteElementQuestion: '¿Está seguro que desea eliminar este elemento?',
    activateElementQuestion: '¿Está seguro que desea activar este elemento?',
    deactivateElementQuestion:
      '¿Está seguro que desea desactivar este elemento?',
    searchNotFound: 'Tú búsqueda para {search} no produjo resultados.',
    close: 'Cerrar',
    optional: 'Opcional',
    add: 'Agregar',
    remove: 'Remover',
    plan: 'Plan',
    reports: 'Reportes',
    report: 'Reporte',
    expense: 'Gasto',
    discount: 'Descuento',
    iva: 'IVA',
    totalExpenses: 'Gastos Totales',
    search: 'Buscar',
    searchForClick: 'Buscar (presione enter para hacer la búsqueda)',
    yes: 'Si',
    no: 'No',
    filter: 'Filtrar',
    filterBy: 'Filtrar por',
    satXmlDownload: 'Xml pendiente para descargar del SAT',
    xmlDownload: 'Descargas XML',
    downloadAppDesktop: 'Descargar aplicacion de escritorio',
    chooseLanguage: 'Elija idioma',
    active: 'Activo',
    inactive: 'Inactivo',
    logo: 'Logotipo',
    noResults: 'Sin resultados',
    locale: 'es-es',
    downloadReport: 'Descargar reporte',
    taxes: 'Impuestos',
    selectFilters: 'Seleccionar filtros',
    image: 'imagen',
    employee: 'Empleado',
    year: 'Año',
    month: 'Mes',
    paid: 'Gastos completados',
    next: 'Siguiente',
    pay: 'Pagar',
    view: 'Ver',
    downloadXML: 'Descargar XML',
    optionalField: ' (Opcional)',
    months: {
      jan: 'Ene',
      feb: 'Feb',
      mar: 'Mar',
      apr: 'Abr',
      may: 'May',
      jun: 'Jun',
      jul: 'Jul',
      aug: 'Ago',
      sep: 'Sep',
      oct: 'Oct',
      nov: 'Nov',
      dec: 'Dic'
    },
    seeMore: 'Ver más',
    back: 'Atrás',
    advance: 'Anticipo',
    totalAmountCheck: 'Gasto total',
    advanceExpense: 'Comprobación de anticipo',
    noHave: 'No tiene',
    payment: 'Devolución',
    refund: 'Reembolso',
    details: 'Detalles',
    withoutRestrictions: 'Sin restricciones',
    contacts: 'Contactos',
    reason: 'Motivo',
    message: 'Mensaje',
    deleteContact: 'Eliminar Contacto',
    expenseDate: 'Fecha factura',
    accept: 'Aceptar',
    createdBy: 'Creado por',
    assigned: 'Asignado',
    all: 'Todos',
    default: 'Predeterminado',
    defaults: 'Predeterminada',
    incomplete: 'Incompleto',
    paymentsMade: 'Pagos realizados',
    downloadExpensesFiles: 'Descarga de archivos de gastos',
    expensesFiles: 'Archivos de gastos',
    download: 'Descargar',
    availableFiles: 'Archivos disponibles',
    transactionDate: 'Fecha de transacción',
    totalAmount: 'Monto total',
    availableAmount: 'Monto disponible',
    totalAmountPetty: 'Monto total en Caja chica/Tarjeta AMEX',
    oneOptionRequired: 'Debes seleccionar al menos una opción',
    validationError: 'Existen errores en la validación de los datos. <br/> Por favor, compruebe el formulario nuevamente.',
    errorChargeDataByRangeDate: 'Intente con un rango de fechas menor',
    updateStartDate: 'Se actualizo el rango de fecha inicial',
    updateEndDate: 'Se actualizo el rango de fecha final',
    nonAllowedCharacters: 'Caracteres no permitidos',
    verifyEFOS: 'Verificar EFOS',
    certifiedDate: 'Fecha de timbrado',
    folio: 'Folio',
    warning: 'Precaución',
    success: 'Correcto',
    searching: 'Buscando',
    loading: 'Cargando',
    print: 'Imprimir',
    receipt: 'Recibo',
    receiptUniversal: 'Recibo de gastos',
    searchNoMatch: 'Ningún resultado coincide con su búsqueda.',
    ruc: 'RUC',
    dv: 'DV',
    is_national: '¿Es Nacional?',
    myExpenses: 'Gastos faltantes',
    myExpensesNew: 'Mis gastos',
    collapse: 'Contraer',
    extend: 'Extender',
    cardNumber: 'Número de tarjeta AMEX',
    cardAbbr: 'Tarjeta AMEX',
    cardNumberAbbr: 'No. Tarjeta AMEX',
    conciliations: 'Conciliaciones',
    noDefined: 'No definido',
    loadingText: 'Cargando... Por favor espere',
    noDataText: 'No hay datos para mostrar',
    previous: 'Anterior',
    waitingMessage: 'Cargando datos, por favor espere...',
    type: 'Tipo',
    amountSpent: 'Monto gasto',
    generalSearch: 'Buscar por: ',
    downloadFiles: 'Descarga de archivos',
    undo: 'Deshacer',
    editSave: 'Editar y Guardar',
    editSend: 'Editar y Enviar',
    businessUnit: 'Unidad de negocios',
    downloadLayout: 'Descargar layout',
    downloadLayoutByExpense:  'Descargar layout por comprobación',
    addExpenseIdLayout: 'Comprobación (Presione enter en caso de agregar manualmente)',
    layoutList: 'Layout por listado',
    reportListId: 'Descargar reporte por listado',
    erpExportLog: 'Layout descargados',
    erpExportLogOne: 'Layout descargado',
    generateLayoutBank: 'Layout bancario',
    generateLayoutERP: 'Layout ERP',
    generateLayoutHelperXml: 'Auxiliar XML',
    payGenerateLayout: 'Pagar y generar layout',
    Accountingid: 'Cuenta contable',
    Addbussinessunit: '¿Agregar unidad de negocios?',
    NextXml: 'Siguiente xml',
    reasonForRejection: 'Razón de rechazo',
    okBlue: 'Vale azul',
    checked: 'Comprobado',
    toCheck: 'Por comprobar',
    voucherAmount: 'Monto en vales',
    remainingAmount: 'Monto restante',
    amountPettyCash: 'Monto en caja chica',
    availableBox: 'Disponible en caja',
    alls: 'Todas',
    missingReserveExpenses: 'Gastos faltantes de reservas',
    with: 'con',
    commentFrom: 'Comentario de',
    clean: 'Limpiar',
    create: 'Crear',
    charge: 'Cargar',
    multiProjects: 'Multiproyectos',
    selectMultiProjects: 'Seleccione multiproyectos',
    errorResponseMultiple: 'Algunos datos no se guardaron correctamente, verifique y vuelva intentar.',
    max30Data: 'Solo se puede enviar máximo 30 registros a la vez',
    amountMax: 'Monto máximo',
    selectDates: 'Seleccionar fechas',
    invalidCodes: 'Códigos inválidos',
    invalidCodesMessage: 'Los siguientes códigos no son válidos: {codes}. Por favor, verifique los códigos y vuelva a intentarlo.',
    pettyCashAmex: 'Caja chica/Tarjeta AMEX',
    addAmountCorrect: 'Agregue un monto correcto',
    erroTimeout: 'Tiempo de espera de la solicitud excedido, intente nuevamente',
  },
  dataTable: {
    noResult: 'No se encontraron registros',
    loadingRecords: 'Cargando registros'
  },
  address: {
    name: 'Dirección',
    street: 'Calle',
    city: 'Ciudad',
    state: 'Estado',
    country: 'País',
    zip: 'C.P.'
  },
  taxFields: {
    taxId: 'RFC',
    phone: 'Teléfono',
    regime: 'Régimen fiscal',
    socialReason: 'Razón social'
  },
  categories: {
    name: 'Categoría',
    add: 'Agregar categoría',
    edit: 'Editar categoría',
    delete: 'Eliminar categoría',
    new: 'Nueva categoría',
    description: 'Nombre de la categoría',
    setDefault: 'Seleccionar como predeterminada',
    loadDefault: 'Cargar Categorías predeterminadas',
    confirmDefault:
      '¿Estás seguro que desea cargar las siguientes categorías por defecto? Puedes agregar o modificar categorías más tarde.',
    warning:
      'La empresa no tiene definida una categoría predeterminada. Para hacer uso de la carga de archivos XML en el sistema de forma correcta, Seleccione una categoría como predeterminada',
    ct: {
      fuel: 'Combustible',
      meals: 'Alimentos',
      hotel: 'Hoteles',
      tollGates: 'Casetas',
      transportation: 'Transporte',
      others: 'Otros'
    },
    group: 'Grupo',
    analyticalAccount: 'Cuenta analítica',
    analyticalDescription: 'Descripción analítica',
    accountingAccount: 'Cuenta contable',
    accountingDescription: 'Descripción contable',
    AddanalyticalAccount: '¿Agregar cuenta analítica?'

  },
  travelTypes: {
    name: 'Tipos de viaje',
    nameView: 'Gastos de tipo de viaje',
    add: 'Agregar',
    edit: 'Editar tipo de viaje',
    delete: 'Eliminar tipo de viaje',
    new: 'Nuevo tipo de viaje',
    description: 'Nombre del tipo de viaje',
    setDefault: 'Seleccionar como predeterminado',
    loadDefault: 'Cargar tipos de viaje predeterminados',
    confirmDefault:
      '¿Estás seguro que desea cargar los siguientes tipos de viaje por defecto? Puedes agregar o modificar tipos de viaje más tarde.',
    warning:
      'La empresa no tiene definida un tipo de viaje predeterminado. Para hacer uso de la carga de archivos XML en el sistema de forma correcta, Seleccione un tipo de viaje como predeterminado'
  },
  expenses: {
    subtitle: 'Historial de comprobaciones',
    commentRequired: 'El comentario es requerido',
    errorConcept: 'Falta agregar información en los conceptos',
    errorCountConcept: 'Agregue al menos un concepto en el gasto',
    errorCountConceptLine: 'Rellene el campo descripción en los conceptos',
    errorCountConceptAmount: 'Los montos de los conceptos deben ser mayor a 0',
    errorCountConceptCategory: 'Asegúrese seleccionar las categorías en los conceptos',
    name: 'Comprobación',
    add: 'Agregar comprobación',
    create: 'Crear comprobación',
    addFiscalExpense: 'Agregar gasto Fiscal',
    addNoFiscalExpense: 'Agregar gasto No Fiscal',
    edit: 'Editar comprobación',
    attach: 'Adjuntar archivos',
    required_attachment: 'Archivo adjunto requerido',
    attachedFiles: 'Archivos adjuntos',
    file: 'Archivo',
    files: 'Archivos',
    noFiles: 'No tiene archivos adjuntos',
    fileType: 'Tipo de archivo',
    delete: 'Eliminar comprobación',
    new: 'Nueva comprobación',
    selectExpense: 'Seleccionar comprobación',
    relateExpense: 'Relacionar comprobación',
    description: 'Descripción de la comprobación',
    start: 'Iniciar',
    startWorkflow: 'Iniciar flujo de trabajo',
    sendValidation: 'Enviar a validar',
    xmlPending: 'Tienes algunos XML que están pendientes para descarga del SAT antes de poder iniciar el flujo de trabajo',
    startWorkflowQuestion: '¿Esta seguro que desea iniciar el flujo de trabajo de la comprobación seleccionada?',
    sendValidationMessage: '¿Esta seguro que desea enviar a validar la comprobación?',
    sendValidationMultiProject: 'Esta realizando modificaciones en los proyectos. Revise las asignaciones de sus gastos antes de enviar a validación',
    selectedExpense: 'Seleccione una comprobación',
    view: 'Ver comprobación',
    viewMessage: '¿Le gustaría ir a las comprobaciones?',
    exs: {
      created: 'Creado',
      sented: 'Enviado',
      reviewed: 'Revisado',
      payable: 'Por pagar',
      payment: 'Pago parcial',
      paid: 'Completado',
      approved: 'Aprobado',
      complete: 'Completado',
      validator: 'Validador'
    },
    status: {
      created: 'Creadas',
      sented: 'Enviadas',
      reviewed: 'Revisadas',
      payable: 'Por pagar',
      payment: 'Pago parcial',
      paid: 'Completadas',
      complete: 'Completado',
      approved: 'Aprobada',
      rejected: 'Rechazada'
    },
    statExpense: {
      new: 'Nuevo',
      rejected: 'Rechazado'
    },
    history: {
      pending: 'Pendiente',
      sented: 'Enviado por',
      reviewed: 'Revisado por',
      payable: 'Aprobado por',
      paid: 'Pagado por',
      assignedvalidator: 'Validador asignado',
      inRepresentationOf: 'En representación de'
    },
    toPettyCash: 'A Caja chica/Tarjeta AMEX',
    pettyExpense: 'Comprobación de Caja chica/Tarjeta AMEX',
    tracking: 'Seguimiento del gasto',
    downloadAccuse: 'Descargar acuse',
    progress: 'Progreso',
    amountMessage: 'El monto debe ser en la moneda del gasto',
    tip: 'Propina',
    addTip: 'Agregar propina al gasto',
    addWatchTip: 'Agregar/Ver propina',
    seeTip: 'Ver propina',
    reservations: {
      users: 'Usuarios',
      cashier: 'Cajero',
      showRelations: 'Mostrar relaciones',
      generateRelationship: 'Generar relación',
      close: 'Cerrar',
      tellerRelationship: 'Relación de representantes',
      title: 'Reservaciones',
      add: 'Agregar reservación',
      simple: 'Reserva de comprobaciones',
      request: 'Reservación por solicitud'
    },
    relateToRequest: '¿Desea relacionar con una solicitud de gastos?',
    pendingExpenses:
      'Tiene {totalPending} gastos Amex pendientes por subir. Tiene un plazo no mayor a 5 dias para reportar',
    filterMessage:
      'Debe filtrar a partir del 01 de Diciembre de 2021 a la fecha actual para ver los gastos correspondientes',
    type: 'Tipo de comprobación',
    amountOf: 'Monto de',
    filter: {
      startDate: 'Fecha inicial de la comprobación',
      endDate: 'Fecha final de la comprobación'
    },
    toRelate: 'Por relacionar',
    categoriesPending: 'Categorías por relacionar',
    categoriesPendingMessage:
      'Tiene {pending} categorías pendientes por relacionar a un gasto, se indicarán en el selector de categorías al crear un gasto',
    expenseCharged: 'Gasto cargado exitosamente, pendiente por conciliar',
    resetToReconcile: 'Reestablecer para conciliar',
    confirmReset: 'Confirmar reestablecimiento gasto AMEX',
    resetQuestion:
      '¿Esta seguro que desea reestablecer a "Por conciliar" el gasto AMEX',
    transactionNumber: 'Número de transacción',
    reservationExpType: 'Comprobación proveniente por tipo de Reserva',
    backCheckout: 'Regresar comprobación',
    attentionBackCheckout: 'Atención: Los gastos de la comprobación con numero <b>{expenseId}</b> se regresarán a la bandeja del usuario <b>{userName}</b> para que pueda modificarlos y volver a enviar la comprobación, ¿desea continuar?',
    returnedExpense: 'Gasto regresado:',
    editPeriod: 'Editar periodo',
    noApproverDefault: 'Sin aprobador, contacte a su administrador',
    blueVoucher: {
      errorValidationAmount: 'No cumple con el monto del vale',
      warning: 'Recuerda adjuntar el vale azul en el primer gasto registrado. Debe completar el monto del vale y no exceder el 10% adicional',
      amountNotComplyRules: 'El monto comprobado no cumple con las reglas del vale azul',
      errorFile: 'Debe adjuntar el vale azul en el primer gasto para enviar la comprobación',
      errorWorkFlow: 'Es necesario adjuntar el vale',
      addAmount: 'Agregue monto del vale'
    },
    travelExpense: {
      title: 'Viáticos',
      errorValidationAmount: 'No cumple con el monto del viatico',
      warning: 'Recuerda adjuntar el viatico en el primer gasto registrado. Debe completar el monto del viatico y no exceder el 10% adicional',
      amountNotComplyRules: 'El monto comprobado no cumple con las reglas del viatico'
    },
    errorAmount: 'No cumple con el monto del gasto',
    missingExpenses: {
      unloadedExpenses: 'No cargados',
      loadedWithoutVerification: 'Cargados sin comprobación',
      loadedWithVerification: 'Cargados con comprobación',
      Approved: 'Aprobados',
    },
    idExpenseSearch: '# de comprobación (Presione enter para buscar)',
  },
  projects: {
    status: {
      active: 'Activos',
      inactive: 'Inactivos'
    },
    stat: {
      active: '(Activo)',
      inactive: '(Inactivo)'
    }
  },
  expenseItems: {
    name: 'Gasto',
    add: 'Agregar gasto',
    delete: 'Eliminar gasto',
    fiscal: 'Gasto fiscal',
    manual: 'Gasto no fiscal',
    description: 'Descripción del gasto',
    noFileUploaded: 'No se ha cargado una imagen del gasto',
    title: 'Subir gastos',
    readItemProgress: 'Leyendo gasto {current} de {total}',
    watchFile: 'Ver archivo',
    blackList: 'RFC Emisor en las lista negra:',
    downloadProcess: 'Existen gastos en proceso de descarga',
    verifyEFOMsg: 'Verificada en lista 69-B del SAT (No es EFO)',
    exchangeRate: 'TC',
    referenceNumber: 'No. Referencia',
    voucherType: 'Tipo',
    deleteConcepts: 'Eliminar concepto',
    handleRowDoubleClick: 'Doble clic para ver gastos'
  },
  userApplication: {
    name: 'Usuario de aplicación',
    add: 'Agregar usuario de aplicación',
    delete: 'Eliminar relación de usuario con aplicación',
    relationshipOfUser: 'Relación de usuario',
    withApplication: 'con aplicación'
  },
  validation: {
    required: 'El elemento es requerido',
    minNumberChars: 'Mínimo {number} letras',
    minNumberChar: 'Mínimo {number} caracteres',
    maxNumberChar: 'Máximo {number} caracteres',
    maxNumberChars: 'Máximo {number} letras',
    exactNumberChars: 'El elemento debe tener exactamente {number} letras',
    minNumberDigits: 'El elemento debe tener más de {number} digitos',
    maxNumberDigits: 'El elemento no debe tener más de {number} digitos',
    exactNumberDigits: 'El elemento debe tener exactamente {number} digitos',
    invalidEmail: 'Correo electrónico inválido',
    invalidDecimal: 'Decimal inválido',
    noSpecialChars: 'El elemento no debe tener ningún caracter especial',
    exchange: '4 dígitos y hasta 6 decimales permitidos',
    pettyCashAdvance: '6 dígitos y hasta 2 decimales permitidos',
    fiveDigits: '5 dígitos',
    invalidNumber: 'Número inválido',
    onlyLetters: 'El elemento sólo debe contener letras',
    noSpace: 'El elemento solo debe ser una palabra',
    deleteUserQuestion:
      '¿Estás seguro de eliminar el usuario <b>{name}</b> con el correo electrónico: <b>{email}</b>?',
    deleteSubscriptionQuestion:
      '¿Estás seguro de eliminar la suscripción de <b>{company}</b>?',
    passwordsDoNotMatch: 'Las contraseñas no coinciden',
    success: 'Éxito',
    error: 'Error',
    maxNumChars: 'El elemento no debe tener más de {number} caracteres'
  },
  user: {
    name: 'Usuario',
    add: 'Agregar usuario',
    addBatch: 'Agregar usuarios por lote',
    edit: 'Editar usuario',
    delete: 'Eliminar usuario',
    avatar: 'Avatar',
    gender: 'Género',
    male: 'Hombre',
    female: 'Mujer',
    birthDate: 'Fecha de nacimiento',
    activate: 'Activar',
    downloadTemplate: 'Descargar plantilla',
    addConfirm: 'Confirmación de usuario',
    addQuestion: 'Está por agregar a este usuario. Por favor, confirme la información antes de continuar',
    employeeNumber: 'Número de empleado',
    policyAddress: 'Dirección de póliza',
    depositBank: 'Banco de depósito',
    bankAccount: 'Cuenta bancaria',
    RFC: 'RFC',
    Taxid: 'Tax ID',
    AddempBa: '¿Agregar datos bancarios del empleado?',
    costCenter: 'Centro de costos',
    subtitle: 'Gestión de usuarios'
  },
  approver: {
    name: 'Aprobador',
    assign: 'Asignar aprobador',
    add: 'Agregar aprobador',
    edit: 'Editar aprobador',
    select: 'Seleccionar aprobador',
    selectUser: 'Seleccionar usuario',
    delete: 'Eliminar aprobador',
    sure_remove: '¿Estás seguro de eliminar el aprobador actual?',
    current: 'Aprobador actual',
    duplicate: 'El usuario seleccionado es actualmente un aprobador',
    default: 'Elegir usuario por defecto',
    default_message: '¿Desea elegir el siguiente usuario por defecto?',
    deleteUserQuestion:
      '¿Estás seguro de eliminar al aprobador <b>{name}</b>?'
  },
  area: {
    name: 'Área',
    add: 'Agregar área',
    edit: 'Editar área',
    delete: 'Eliminar área',
    description: 'Descripción del área'
  },
  branch: {
    name: 'Sucursal',
    add: 'Agregar sucursal',
    company: 'Compañia',
    edit: 'Editar sucursal'
  },
  company: {
    name: 'Compañia',
    add: 'Agregar compañia',
    edit: 'Editar compañia'
  },
  login: {
    oldPass: 'Contraseña Antigua',
    newPass: 'Nueva contraseña',
    confirmPass: 'Confirmar contraseña',
    password: 'Contraseña',
    label: 'Iniciar sesión',
    recoverPassword: 'Recuperar contraseña',
    forgotYourPasswordQuestion: '¿Olvidó su contraseña?',
    signInExistingAccount: 'Iniciar sesión en cuenta existente',
    useTheFormBelow: 'Use el formulario de abajo para recuperarla.',
    welcome: 'Bienvenido,',
    signInToAccount: 'Por favor inicie sesión con su cuenta.',
    sessionExpired: 'Su sesión ha expirado',
    inspectructRef: '¿Necesitas inspeccionar unidades de transporte? Conoce Inspectruck',
    portability: 'Portabilidad',
    mobilePlatform: 'Plataforma móvil',
    availability: 'Disponibilidad 24/7',
    continuousImprovement: 'Mejora continua',
    reportsAndStatistics: 'Reportes y estadísticas',
    accompaniment: 'Acompañamiento',
    StoringData: 'Almacenamiento de datos y facturas en la nube',
  },
  permission: {
    name: 'Permiso',
    add: 'Agregar permiso',
    edit: 'Editar permiso',
    delete: 'Eliminar permiso',
    description: 'Descripción del permiso'
  },
  project: {
    name: 'Proyecto',
    add: 'Agregar proyecto',
    edit: 'Editar proyecto',
    delete: 'Eliminar proyecto',
    activate: 'Activar proyecto',
    deactivate: 'Desactivar proyecto'
  },
  restriction: {
    name: 'Restricción',
    add: 'Agregar restricción',
    edit: 'Editar restricción',
    delete: 'Eliminar restricción',
    type: 'Tipo de restricción',
    warningQuestion: '¿Es una advertencia?',
    warning: 'Es advertencia',
    date: 'Seleccione una fecha',
    requiredFile: 'Adjuntos requeridos',
    restrictionBy: 'Restricción por',
    rt: {
      amount: 'Monto',
      date: 'Fecha',
      paymentType: 'Tipo de pago',
      currency: 'Moneda',
      amountByDay: 'Cantidad por día',
      attachFile: 'Archivo adjunto',
      description: 'Palabras clave'
    }
  },
  role: {
    ADMIN: 'Admin',
    EMPLOYEE: 'Empleado',
    name: 'Rol',
    add: 'Agregar rol',
    edit: 'Editar rol',
    delete: 'Eliminar rol',
    addPermission: 'Agregar permiso a: {permission}',
    removePermission: 'Remover permiso a: {permission}',
    noPermission: 'No tiene permisos aún'
  },
  setting: {
    name: 'Ajuste',
    add: 'Agregar ajuste',
    edit: 'Editar ajuste',
    delete: 'Eliminar ajuste',
    type: 'Tipo de ajuste',
    periodType: 'Tipo de periodo',
    deadline: 'Día de corte',
    selectPeriodType: 'Seleccione el tipo de periodo',
    weekly: 'Seleccione el día de la semana de su corte',
    biweekly: 'Seleccione el día de corte de la primera quincena del mes',
    monthly: 'Seleccione el día de corte del mes',
    requiredComment: 'Comentario Requerido',
    value: 'Valor',
    days: 'Dias de extensión',
    selectCurrencyType: 'Seleccione el tipo de moneda',
    selectCountryType: 'Seleccione el tipo de país',
    CurrencyType: 'Tipo de moneda',
    CountryType: 'Tipo de país',
    st: {
      period: 'Periodo',
      expenseComment: 'Comentario del gasto',
      dateExtension: 'Ampliación de fecha',
      currency: 'Moneda',
      country: 'País'
    },
    pt: {
      weekly: 'Semanal',
      biweekly: 'Quincenal',
      monthly: 'Mensual'
    }
  },
  validator: {
    name: 'Validador',
    assign: 'Asignar validador',
    edit: 'Editar validador',
    delete: 'Eliminar validador',
    selectEmployee: 'Seleccionar empleado',
    selectArea: 'Seleccionar área',
    date: 'Fecha de validación'
  },
  workflow: {
    name: 'Flujo de trabajo',
    step: 'Paso',
    addApprover: 'Agregar aprobador al flujo',
    addValidator: 'Agregar validador',
    addValidatorIn: 'Agregar validador en: {area}',
    add: 'Agregar flujo de trabajo',
    substitute: 'Substituto',
    element: 'Crear elemento',
    description: 'Descripción del flujo de trabajo',
    changePlace: 'Cambiar de lugar',
    replaceValidator: 'Seleccione el validador que desea reemplazar',
    workflowPosition: 'Posición del flujo de trabajo',
    noSubstitute: 'No tiene',
    workflowName: 'Nombre del proceso de flujo',
    existConfirm:
      'Este validador ya existe en un punto del flujo de trabajo, ¿Estás seguro de que deseas continuar?',
    validatorExist: 'Este validador ya existe en un punto del flujo de trabajo'
  },
  substitutes: {
    name: 'Substituto',
    add: 'Agregar substituto',
    assign: 'Asignar substituto'
  },
  dropzone: {
    default: 'Arrastre y suelte archivos aquí para cargarlos.<br> Máximo {size}{unit}',
    defaultMaxFiles: 'Arrastre y suelte máximo {amount} archivos aquí para cargarlos.<br> Máximo {size}{unit}',
    fallback: 'El navegador no es compatible, se utilizará la carga simple',
    fileTooBig:
      'El archivo es demasiado grande, el archivo tiene un tamaño de {{filesize}} y el límite es {{maxFilesize}}',
    invalidFileType: 'Tipo de archivo no permitido',
    responseError:
      'Ocurrió un error al procesar la carga del archivo, código: {{statusCode}}',
    cancelUpload: 'Cancelar carga',
    uploadCanceled: 'Carga cancelada',
    cancelUploadConfirmation: '¿Desea cancelar la carga del archivo?',
    removeFile: 'Quitar archivo',
    removeFileConfirmation: '¿Desea quitar el archivo?',
    maxFilesExceeded: 'Límite de número de archivos excedido',
    limitedFiles: 'El archivo {nameFile} no se agregara a la solicitud por que excede el máximo de archivos por solicitud',
    textFileXml:
      'Arrastre y suelte archivos xml aquí para cargarlos.<br> Máximo {size}{unit}',
    uploadUserBatch:
      'Arrastre y suelte o de clic aquí para cargar la plantilla de lote de usuarios.<br> Máximo {size}{unit}',
    uploadAMEXBatch:
      'Arrastre y suelte o de clic aquí para cargar la plantilla de lote de gastos AMEX.<br> Máximo {size}{unit}'
  },
  subscriptions: {
    name: 'Suscripción',
    application: 'Aplicación',
    expiration_date: 'Fecha expiración',
    add: 'Agregar suscripción',
    edit: 'Editar suscripción',
    expirationDate: 'Fecha de expiración',
    delete: 'Eliminar suscripción',
    vigent: 'Vigente',
    expired: 'Expirada',
    toExpire: 'Por expirar',
    renovations: 'Renovaciones'
  },
  history: {
    name: 'Mi Historial',
    selectDate: 'Seleccionar rango de fechas',
    noItem: 'No hay ningún elemento',
    local: 'es-es',
    allCategories: 'Todas las categorías',
    perCategorie: 'Por categoría',
    allProjects: 'Todos los proyectos',
    perProject: 'Por proyecto',
    allStatus: 'Todos los status',
    perStatus: 'Por status'
  },
  employerReports: {
    name: 'Reportes por empleado',
    startDate: 'Fecha inicio',
    endDate: 'Fecha de fin',
    filters: [
      {
        label: 'Rango de Fecha',
        value: 'date'
      },
      {
        label: 'Área',
        value: 'area'
      },
      {
        label: 'Oficina',
        value: 'office'
      },
      {
        label: 'Sucursal',
        value: 'branch'
      },
      {
        label: 'Proyecto',
        value: 'project'
      }
    ]
  },
  reportsType: {
    name: 'Gastos acumulados por categoría',
    description: 'Obtén montos totales de gastos agrupados por categorías, y filtrado por usuarios específicos.',
    selectDate: 'Selecciona el rango de fechas',
    local: 'es-es',
    concepts: 'Conceptos',
    category: 'Categoría',
    subtotal: 'Subtotal',
    descount: 'Descuento',
    iva: 'IVA',
    total: 'Total',
    currency: 'Moneda',
    resetForm: 'Resetear formulario'
  },
  notifications: {
    name: 'Notificación',
    all: 'Todas las notificaciones',
    title: 'Título',
    message: 'Mensaje',
    messages: 'Mensajes',
    status: 'Estado',
    application: 'Aplicación',
    notificationType: 'Tipo de notificación',
    markAsRead: 'Marcar como leído',
    read: 'Leído',
    pending: 'Pendiente',
    youHave: 'Tiene',
    unreadMessages: 'mensajes sin leer.',
    date: 'Fecha',
    time: 'Hora',
    delete: 'Eliminar Notificación',
    confirmDelete: '¿Estás seguro de que deseas eliminar esta notificación?',
    Module: 'Módulo'
  },
  expensesApproved: {
    name: 'Gastos aprobados',
    single: 'Gasto aprobado'
  },
  expenseDetailEmployee: {
    nameEmployee: 'Reporte por empleado',
    nameEmployees: 'Gastos detallados por empleado',
    downloadUserSummary: 'Descargar resumen por empleado',
    nameDetailEmployee: 'Reporte detallado por empleado',
    nameDetailEmployees: 'Gastos detallados por empleado',
    myDetailReport: 'Mi reporte detallado',
    description: 'Obtén datos específicos para saber los gastos que ha emitido cada usuario, este reporte permite filtrar por fechas abiertas.',
    download: 'Descargar reporte',
    employee: 'Empleado',
    perEmployee: 'Por Empleado',
    perCategorie: 'Por Categoría',
    perStatus: 'Por Estatus',
    perDate: 'Por Fecha',
    perArea: 'Por Áreas',
    perProject: 'Por Proyecto',
    allEmployees: 'Todos los empleados',
    allCategories: 'Todas las categorías',
    allStatus: 'Todos los Estatus',
    allDates: 'Todas las fechas',
    allAreas: 'Todas las Áreas',
    allProjects: 'Todos los Proyectos',
    detail: 'Con detalle',
    noDetail: 'Sin detalle',
    noResults: 'No se encontraron resultados',
    dateError: 'La fecha de inicio no puede ser mayor a la fecha de fin',
    headers: {
      itemId: 'Item ID',
      category: 'Categoría',
      description: 'Descripción',
      country: 'País',
      uuid: 'UUID',
      subtotal: 'Subtotal',
      total: 'Total',
      currency: 'Moneda',
      exchange: 'Tipo de cambio',
      grandTotal: 'Gran total',
      employee: 'Empleado',
      status: 'Estado'
    }
  },
  workflowValidation: {
    add: 'Agregar gastos a la comprobación',
    reject: 'Gasto Rechazado',
    approb: 'Gasto Aprobado',
    commentV: 'Comentarios',
    expense: 'Comprobación No. ',
    expenseNo: 'No. Comprobación',
    item: 'Gasto No. ',
    typeItem: 'Tipo',
    viewItem: 'Ver y Editar Gasto',
    selectItems: 'Selecciona los elementos que desée agregar a la comprobación',
    comment: 'Ver Comentario',
    dateExpense: 'Fecha de comprobación:',
    approbad: 'Aprobar',
    valid: 'Validar',
    rejec: 'Rechazar',
    confirmR: 'Confirmación de gasto por rechazar',
    rechazE: 'Está por rechazarse el gasto No. ',
    confirmRejectMultiple: 'Confirmación de gastos por rechazar',
    rejectedAboutExpense: 'Están por rechazarse los gastos. No. ',
    descriptionE: 'Describe el motivo del rechazo',
    confirmAp: 'Confirmación de aprobar esta comprobación',
    confirmValid: 'Confirmación de validar esta comprobación',
    approbE: '¿Estás seguro que deseas aprobar la comprobación No. ',
    validE: '¿Estás seguro de que deseas validar la comprobación No.',
    appro: 'Aprobar Gastos',
    nameUser: 'Nombre del usuario: ',
    areaW: 'Área: ',
    categoryW: 'Categoría: ',
    typeReceipt: 'Tipo de Gasto: ',
    listExpenses: 'Lista de gastos de la comprobación No. ',
    viewExpensesItems: 'Ver Gastos',
    showImage: 'Mostrar imagen',
    hideImage: 'Ocultar imagen',
    changeImage: 'Cambiar archivo',
    addOptionalComment: 'Agregar comentario opcional',
    validatorComments: 'Comentario de validadores',
    abbrExpenseNo: 'No. Comp',
    addPendingExpenses: 'Agregar gastos pendientes',
  },
  annualExpensesReport: {
    name: 'Gastos anuales por categoría',
    year: 'Año',
    description: 'Obtén montos totales de gastos que fueron completados en el lapso de un año, organizado por mes y categoria.'
  },
  reports: {
    reportAnnualExpensesBranch: 'Gastos anuales por sucursal',
    reportAnnualExpensesBranchDesc: 'Obtén montos totales de gastos que fueron completados en el lapso de un año, organizado por mes y sucursal.',
    reportExpensesCategoryBranch: 'Gastos por categorías y sucursales',
    reportExpensesCategoryBranchDesc: 'Obtén montos totales de gastos por categorías y sucursales'
  },
  profiles: {
    companyProfile: 'Perfil de Compañía',
    companyName: 'Nombre de compañía',
    planInfo: 'Información del plan',
    lang: 'Idioma',
    deadline: 'Fecha de corte',
    minUsers: 'Usuarios Mínimos',
    maxUsers: 'Usuarios Máximos',
    userProfile: 'Perfil de Usuario',
    userInfo: 'Información del Usuario',
    changeAvatar: 'Cambiar imagen de perfil',
    changeLogo: 'Cambiar logo de compañía',
    changePassword: 'Cambiar contraseña',
    male: 'Hombre',
    female: 'Mujer'
  },
  reportsByConcept: {
    name: 'Gastos detallados por categoría',
    description: 'Obtén la lista de gastos detallados de usuarios filtrados por categorías.',
    id: 'ID',
    date: 'Fecha',
    state: 'Estado del gasto',
    UUID: 'UUID',
    expenseC: 'Concepto del gasto',
    category: 'Categoría',
    subtotal: 'Subtotal',
    taxes: 'Impuestos',
    originalT: 'Total Original',
    currency: 'Moneda',
    exchange_rate: 'Tipo de cambio',
    total: 'Total',
    madeExpense: 'Empleado',
    area: 'Área',
    local: 'es-es'
  },
  keywords: {
    add: 'Agregar palabras clave',
    addOne: 'Agregar palabra clave',
    edit: 'Editar palabra clave',
    delete: 'Eliminar palabra clave',
    keyword: 'Palabra clave',
    empty: 'Aún no hay palabras clave',
    exists: 'La palabra clave ya existe',
    keywordEs: 'Palabra clave en Español',
    keywordEn: 'Palabra clave en Inglés',
    insertionLang: 'Idioma de Inserción',
    Es: 'Español',
    En: 'Inglés'
  },
  reportComparative: {
    name: 'Comparativa de gastos',
    description: 'Permite comparar y obtener montos sobre los gastos tomando en cuenta periodos mensuales y trimestrales.',
    rangeOne: 'Rango Uno',
    rangeTwo: 'Rango Dos',
    type: 'Tipo de comparativa',
    usersCategories: 'Usuarios-Categorías',
    periodType: 'Tipo de periodo',
    quarter: 'Trimestre',
    firstDate: 'Primera fecha',
    secondDate: 'Segunda fecha',
    firstQuarter: '1er Trimestre (Ene - Mar)',
    secondQuarter: '2do Trimestre (Abr - Jun)',
    thirdQuarter: '3er Trimestre (Jul - Sep)',
    fourthQuarter: '4to Trimestre (Oct - Dic)',
    differenceAmount: 'Diferencia (monto)',
    differencePercentage: 'Diferencia Gasto (%)'
  },
  reportExpenseTracking: {
    name: 'Seguimiento de comprobaciones',
    seeExpense: 'Ver gasto',
    description: 'Permite dar seguimiento a gastos de usuarios de forma detallada para ver el estado actual, además de ver las líneas cargadas por gasto.'
  },
  ExpensesPayable: {
    name: 'Gastos por pagar',
    paymentAmount: 'Monto a pagar',
    selectAmount: 'Seleccione el monto que desea pagar a esta comprobación',
    remaining: 'Restante',
    amountToPay: 'Monto a pagar',
    paid: 'Finalizar',
    confirmPayment: '¿Está seguro de que desea marcar como pagada la comprobación No.',
    myFlows: 'Mis flujos',
    otherFlows: 'Otros flujos',
    myApprovals: 'Mis aprobaciones',
    descriptionPayMultipleExpense: 'Se procederá a pagar las comprobaciones seleccionadas y a descargar el layout',
    payExpenses: '¿Pagar todas las comprobaciones?'
  },
  annualExpensesByEmployedReport: {
    name: 'Gastos anuales por empleado',
    description: 'Obtén montos totales de gastos por usuarios considerando el lapso de un año (año vigente), los montos son agrupados por meses.'
  },
  ExpensesPaid: {
    name: 'Gastos Completados'
  },
  settings: {
    weekDays: {
      sunday: 'Domingo',
      monday: 'Lunes',
      tuesday: 'Martes',
      wednesday: 'Miércoles',
      thursday: 'Jueves',
      friday: 'Viernes',
      saturday: 'Sábado'
    }
  },
  wizard: {
    period: {
      title: 'Configuración de Ajustes',
      text:
        'En esta pantalla configura el periodo y comentario requerido para los tipos de gastos. “Agregar ajuste”'
    }
  },
  dashboard: {
    loaded: 'Gastos cargados',
    amount: 'Monto de gastos',
    amountByType: 'Monto de gastos aprobados por tipo',
    paidByType: 'Monto de gastos completados por tipo',
    amountApproved: 'Monto de gastos aprobados',
    amountPaid: 'Monto de gastos completados',
    approvedType: 'Tipo de gastos aprobados',
    paidType: 'Tipo de gastos completados',
    expenseByProject: 'Gastos completados por proyecto',
    expenses: 'Gastos',
    quart: 'este Trimestre',
    month: 'este Mes',
    year: 'este Año',
    quarter: 'Trimestral',
    monthly: 'Mensual',
    yearly: 'Anual',
    projectsPerPage: 'Proyectos por página'
  },
  pettyCash: {
    title: 'Caja chica',
    subtitle: 'Gestión de caja chica propia',
    add: 'Hacer movimiento de anticipo',
    addPayment: 'Agregar abono',
    edit: 'Editar caja chica',
    removeCash: 'Remover anticipo',
    removePetty: 'Eliminar anticipo',
    removeQuestion:
      '¿Estás seguro de que deseas remover la caja chica/Tarjeta AMEX de este usuario?',
    history: 'Historial de anticipos',
    currentAmount: 'Monto actual',
    income: 'Ingresos',
    expense: 'Egresos',
    payment: 'Pago',
    withdraw: 'Retirar',
    downloadHistory: 'Descargar Historial',
    downloadRequests: 'Descargar Solicitudes',
    makeMovement: 'Hacer movimiento',
    movementType: 'Tipo de Movimiento',
    cardNumber: 'No. Tarjeta',
    transactionDate: 'Fecha',
    vendor: 'Nombre proveedor',
    transactionNumber: 'No. Transacción',
    description: 'Descripción',
    amount: 'Monto',
    type: 'Tipo',
    expenseType: 'Gasto AMEX',
    creditType: 'Abono a Caja chica/Tarjeta AMEX',
    continue: 'Continuar',
    select: 'Seleccione las partidas a importar',
    cardNumberEmpty: 'Sin número de tarjeta AMEX',
    importAMEX: 'Importar datos AMEX',
    pettyCash: 'Caja chica',
    amexCard: 'Tarjeta AMEX',
    balanceIn: 'Saldo en',
    amexCardMessage: 'Tarjeta Corporativa: Activa',
    requestPettyCash: 'Solicitud de caja chica',
    requestPettyCashEdit: 'Editar solicitud de caja chica',
    requestPettyCashRemove: 'Eliminar solicitud de caja chica',
    requestPettyCashRemoveQuestion:
      '¿Estás seguro de que deseas eliminar esta solicitud de caja chica?',
    requestPettyCashReject: 'Rechazar solicitud de caja chica',
    requestPettyCashRejectQuestion:
      'Para rechazar la solicitud {folio} es necesario que ingrese el motivo del rechazo.',
    requestPettyCashRejected: 'Solicitud rechazada',
    rejectReason: 'Motivo de rechazo',
    reject: 'Rechazar',
    requestPettyCashTracking: 'Seguimiento de la solicitud',
    requestPettyCashValidate: 'Validar solicitud de caja chica',
    requestPettyCashValidateQuestion:
      '¿Estás seguro de que deseas validar esta solicitud de caja chica?',
    requestPettyCashValidationQuestion:
      '¿Estás seguro de que deseas enviar a validar esta solicitud de caja chica?',
    progress: {
      created: 'Creada',
      sented: 'Enviada',
      reviewed: 'Revisada',
      approved: 'Aprobada',
      deposited: 'Abonado a caja chica'
    }
  },
  amexCard: {
    title: 'Tarjeta AMEX',
    edit: 'Editar tarjeta AMEX',
  },
  verifyEFOS: {
    check: 'Comprobar lista negra',
    start: 'Verificar CFDIS',
    searchByTax: 'Buscar RFC',
    searchInfo:
      'Puedes buscar si el RFC del emisor pertenece a la lista negra del SAT',
    verifyCFDIS: 'Verifica si tus CFDIs son emitidos por algún EFOS',
    set: 'Serie',
    taxSuccess:
      'El RFC del emisor {taxID} no se encuentra en la lista de EFOS del SAT',
    taxWarning:
      'El RFC del emisor {taxID} se encuentra en la lista de EFOS del SAT',
    noData: 'No se han encontrado facturas de emisores en la lista de EFOS',
    hasData: 'Se han encontrado facturas de emisores en la lista de EFOS',
    subheader:
      'Identifica aquellas empresas o contribuyentes reconocidos por el SAT que realizan facturas simuladas (compra de facturas o tráfico de comprobantes CFDI)'
  },
  conciliation: {
    titleToReconcile: 'Gastos por conciliar',
    titleReconciled: 'Gastos conciliados',
    titleExcluded: 'Gastos excluidos',
    titleMissing: 'Gastos faltantes',
    status: {
      toConciliate: 'Por conciliar',
      conciliated: 'Conciliados',
      excluded: 'Excluidos',
      missing: 'Faltantes'
    },
    statusLabel: 'Estatus',
    accountNo: 'Numero de cuenta',
    amexExpenseNo: '# AMEX',
    BluExpenseNo: '# Bluespend',
    conciliedExpense: 'Conciliado',
    conciliedDate: 'Fecha conciliado',
    expenseDate: 'Fecha de gasto',
    download: 'Descargar',
    expenseNo: 'No. AMEX',
    date: 'Fecha',
    transactionNo: 'No. Transacción',
    description: 'Descripción',
    beneficiary: 'Beneficiario',
    amount: 'Monto',
    result: 'Resultado',
    foundMessage: 'Se encontraron los siguientes registros coincidentes',
    searchAgain: 'Volver a buscar',
    uuid: 'UUID',
    conciliateExpense: 'Conciliar gasto',
    excludeExpense: 'Excluir gasto',
    conciliate: 'Conciliar',
    exclude: 'Excluir',
    excludeAMEX: 'Excluir gasto AMEX',
    found: 'Encontrado',
    notFound: 'No encontrado',
    searchType: 'Tipo de búsqueda',
    conciliateQuestion: '¿Esta seguro que quiere conciliar este gasto?',
    excludeQuestion: '¿Esta seguro que quiere excluir este gasto?',
    cardQ: '¿Cuenta con tarjeta corporativa AMEX?',
    filter: {
      all: 'Todos los gastos',
      advances: 'Anticipos',
      reconciledExpenses: 'Gastos conciliados',
      missingExpenses: 'Gastos faltantes',
      pettyCashAllExpenses: 'Caja chica/Todos los gastos'
    },
    excludeBy: 'Excluir por',
    user: 'Usuario',
    period: 'Periodo',
    tCAmount: 'Monto TC',
    bluespendReconciledAmount: 'Monto conciliado Bluespend',
    missingAmount: 'Monto faltante',
    excludedAmount: 'Gastos Excluidos',
    notConciliated: 'No conciliado',
    tcExpenses: 'Gastos TC',
    confirmAMountExpenseCharged: 'Confirmar monto de gasto a cargar',
    questionCpmfirmCharge:
      '¿Esta seguro de cargar el gasto con un monto de {amountItem}?',
    sinceAmexAmount: 'ya que el monto de AMEX es de {amountAmex}'
  },
  viatics: {
    downloadExcelReport: 'Descargar reporte excel',
    validateExtension: 'Validar ampliación',
    rejectExtension: 'Rechazar ampliación',
    vehicleQuestion: '¿Requiere vehículo?',
    addExtras: 'Agregar ampliación',
    saveExtras: 'Guardar ampliación',
    addCategorie: 'Agregar categoría',
    numberPeople: '# de personas',
    abbrNumberPeople: '# personas',
    dateStart: 'Fecha inicio',
    dateEnd: 'Fecha fin',
    actions: 'Acciones',
    addComment: 'Agregar comentario',
    addDescription: 'Agregar descripción',
    advanceQuestion: '¿Requiere anticipo?',
    advanceAuthorized: 'Anticipo',
    amountAuthorized: 'Monto autorizado',
    approber: 'Aprobador',
    approberComment: 'Comentario',
    approberDate: 'Fecha',
    approxPrice: 'Precio',
    approxQuantity: 'Cantidad',
    quantity: 'Cantidad',
    abbrQuantity: 'Cant.',
    category: 'Seleccione categoria(s)',
    categoryHeader: 'Categoría',
    commentMessage: 'Haga clic si desea agregar un comentario',
    confirmSendTitle: 'Confirmación de envío de solicitud',
    confirmTitle: 'Confirmación para aprobar solicitud',
    delete: 'Eliminar',
    deleteQuestion: '¿Estás seguro que deseas eliminar la solicitud con folio',
    deleteRequest: 'Eliminar solicitud',
    deleteTitle: 'Confirmación de eliminación de solicitud',
    descriptionMessage: 'Haga clic si desea agregar una descripción',
    destination: 'Cd. Destino',
    details: 'Ver detalles',
    downloadRequest: 'Descargar Solicitud',
    edit: 'Editar solicitud',
    folio: 'Folio',
    from: 'De',
    generalData: 'Datos generales',
    new: 'Nueva solicitud',
    newRequest: 'Generar nueva solicitud',
    origin: 'Cd. Origen',
    place: 'Lugar',
    position: 'Posición',
    requestDate: 'Fecha Solicitud',
    send: 'Enviar a validación',
    saveAndSend: 'Guardar y envíar',
    sendQuestion:
      '¿Estás seguro que deseas guardar y enviar a validar la solicitud con folio',
    status: {
      toValidate: 'Por validar',
      inValidation: 'En validación',
      validated: 'Validadas',
      approbed: 'Aprobadas',
      rejected: 'Rechazadas',
      created: 'Creadas'
    },
    title: 'Solicitud de gastos',
    travelPeriod: 'Seleccione el período',
    travelQuestion: '¿Es un gasto de viaje?',
    travelType: 'Seleccione el tipo de viaje',
    to: 'Al',
    type: 'Tipo',
    reject: 'Rechazar solicitud',
    rejectTitle: 'Confirmación de rechazo de solicitud',
    rejectQuestion:
      'Para rechazar la solicitud {folio} es necesario que ingrese el motivo del rechazo.',
    requestedBy: 'Solicitado por',
    requestDetails: 'Detalles de la solicitud',
    requester: 'Solicitante',
    reasonRejected: 'Motivo de rechazo',
    user: 'Solicitado por',
    validate: 'Validar solicitud',
    validationDescription: 'Si lo desea puede agregar un mensaje de validación',
    validationMessage: 'Datos de validación',
    validateQuestion: '¿Estás seguro que deseas validar la solicitud con folio',
    validators: 'Seleccione validador',
    assignedTo: 'Usuario asignado',
    totalAmountAdvance: 'Monto total de anticipo',
    warningAddExtension: 'No se puede crear mas ampliaciones, la comprobación se encuentra en estado de validación.',
    extension: 'Ampliación',
    validationExtensionAlert: 'Existe una ampliación en proceso de validación.',
    validationCategoryRequiredAlert: 'Debe agregar al menos una categoría.',
    validationExtensionRequiredAlert: 'Debe agregar al menos una categoría a la ampliación.',
    copyExpense: 'Copiar solicitud',
    confirmCopyExpense: '¿Seguro que desea copiar la solicitud?'
  },
  helpDrawer: {
    NotificationsPage: {
      title: 'Página de Notificaciones',
      text:
        'Permite comunicar mensajes en tiempo real, que son generadas por el sistema, basándose en el proceso de gastos.'
    },
    DashboardPage: {
      title: 'Tablero',
      text:
        '<li>Gastos cargados: Indica el total de gastos cargados sin importar el estado que se encuentre.</li></br><li>Monto de gastos: Refleja el monto total en pesos, respecto a los gastos cargados.</li></br><li>Gastos completados: Muestra el total de gastos que ya han sido completados.</li></br><li>Gastos rechazados: Muestra el total de gastos que fueron rechazados.</li></br><li>Monto de gastos aprobados por tipo: Indica el total de los gastos separados por categorias.</li></br><li>Monto de gastos completados: Refleja cuantos gastos fueron completados en cada mes (de acuerdo al filtro que este consultado, mensual, trimestral o anual).</li></br><li>Tipo de gastos completados: Indica cuantos gastos fueron completados por categoria, expresado en un diagrama de aro, donde se refleja el total de gastos y el porcentaje pagado de dicha categoria.</li></br><li>Gastos por proyecto: Refleja el total de gastos que fueron completados por proyecto, en la gráfica refleja los montos por proyecto, y el mes que se pagaron.</li>'
    },
    contactPage: {
      title: 'Página de Contactos',
      text:
        'Muestra datos sobre posibles clientes, que tienen el interés de conocer el sistema y ser contactados de inmediato.'
    },
    UsersPage: {
      title: 'Página de usuarios',
      text:
        '<li>Agregar usuario: Genera nuevos usuarios Administradores y empleados.</li></br><li>Agregar usuarios por lote: Descarga la plantilla con un formato XLS, llena los datos correspondientes y adjunta en la vista del sistema, para la carga por lote de usuarios.</li>'
    },
    ValidatorsPage: {
      title: 'Página de Validadores',
      text:
        '<li>Asignar validador: Genera los validadores que puedan ser utilizados en los procesos de flujo, para las diferentes áreas a utilizar.</li>'
    },
    ValidateRequest: {
      title: 'Página de Validación de Solicitudes',
      text: '<li>Validar solicitud: Permite validar las solicitudes de gastos que se encuentran en proceso de validación, con ello se puede aprobar o rechazar la solicitud, además de agregar comentarios para el solicitante.</li>'
    },
    ValidateRequestPettyCash: {
      title: 'Página de Validación de Solicitudes de Caja Chica',
      text: '<li>POR VALIDAR: Muestra las solicitudes de caja chica que le fueron asignadas para su revisión, puede consultar el seguimiento de cada solicitud, validarla o rechazarla indicando el motivo correspondiente.</li></br><li>POR APROBAR: Muestra las solicitudes de caja chica que ya fueron validadas y están en espera de su aprobación final, desde aquí puede aprobarlas o rechazarlas.</li>'
    },
    missingReserveExpenses: {
      title: 'Página de Gastos faltantes de reservas',
      text: '<li>Permite visualizar y dar seguimiento a los gastos que aún no han sido comprobados respecto a las reservas asignadas, facilitando la identificación de pendientes y la gestión oportuna de comprobaciones.</li>'
    },
    representativesPage: {
      title: 'Página de Representantes',
      text: '<li>Permite administrar los representantes registrados, así como consultar, descargar reportes y eliminar registros según sea requerido para el control de la compañía.</li>'
    },
    TravelTypesPage: {
      title: 'Página de Tipos de Viaje',
      text: '<li>Permite administrar los tipos de viaje utilizados en la compañía, así como agregar, editar, eliminar y establecer un tipo de viaje predeterminado. También ofrece la opción de cargar un conjunto de tipos de viaje por defecto, los cuales son requeridos para el correcto procesamiento de los gastos de viáticos.</li>'
    },
    substitutesPage: {
      title: 'Página de Substitutos',
      text:
        '<li>Agregar substituto: Al agregar  substituto, permite tener a usuarios preparados para su posible selección a reemplazar a un validador, en procesos de flujos determinados.</li>'
    },
    ApproverPage: {
      title: 'Página de Aprobador',
      text:
        '<li>Usuario responsable de aprobar gastos y realizar los pagos correspondientes, solo debe existir un solo aprobador para la compañía.</li>'
    },
    CompaniesPage: {
      title: 'Página de Compañías',
      text:
        'Muestra empresas que están suscritas a la plataforma, indicando sus respectivos datos.'
    },
    SubscriptionsPage: {
      title: 'Página de suscripciones',
      text:
        'Permite generar la relación entre compañía y suscripción solicitada, con esta acción el usuario tendrá acceso a la plataforma hasta la fecha de vencimiento establecida.'
    },
    AreasPage: {
      title: 'Página de Áreas',
      text:
        'Da de alta las áreas que requieras para tu compañia, con ello podrás llevar un control más detallado de  los gastos.'
    },
    BranchesPage: {
      title: 'Página de Sucursales',
      text:
        'Ingresa las sucursales que cuenta su compañía, en los diferentes puntos, registrando los datos que solicite.'
    },
    ProjectsPage: {
      title: 'Página de Proyectos',
      text:
        'Ingresa los proyectos que puedas requerir para reportar gastos. Los proyectos hacen referencia a grupos o equipos en específico, esto con la finalidad de llevar un óptimo control de gasto.</br></br><li>ACTIVOS: Permite mostrar la lista de proyectos que se encuentran activos, esto permite que, al generar gastos pueda ser seleccionado.</li></br><li>INACTIVOS: Permite visualizar aquellos proyectos que fueron desactivados, y no son mostrados para la selección de gastos, en caso de volver a ser requeridos tiene la opción de ser activados.</li>'
    },
    CategoriesPage: {
      title: 'Página de Categorías',
      text:
        'Las categorías son clasificaciones pertenecientes a los gastos, el sistema proporciona un conjunto de categorías que puede utilizar, independiente a ello, usted puede generar más categorías para su compañía.'
    },
    RestrictionsPage: {
      title: 'Página de Restricciones',
      text:
        'Permite establecer restricciones que indican al usuario ciertas  medidas a considerar cuando sube sus gastos y con ello llevar control de la compañía, las restricciones pueden aplicar por área o proyecto, los tipos de restricciones son proporcionados por el sistema.'
    },
    WorkflowPage: {
      title: 'Página de Flujo de Trabajo',
      text:
        'La configuración del flujo de trabajo es totalmente requerido para poder llevar el flujo de validación de gastos. Se pueden configurar varios flujos de trabajo para diferentes áreas, tomando en cuenta validadores registrados para las áreas existentes.</br></br><li>En el flujo podrá configurar los pasos que considere conveniente, para la respectiva validación, así mismo tener la opción para dejar configurado a un substituto en proceso.</li></br><li>Cambiar de lugar: podría cambiar el proceso de flujo del área, ejemplo, si se agregó primero usuario X y posteriormente usuario Y, puede establecer que en primer plano el validador sea usuario Y.</li>'
    },
    Keywords: {
      title: 'Página de Palabras clave',
      text:
        'La configuración de palabras claves permiten identificar fácilmente a qué categoría pertenecen los CFDI cargados, por lo tanto entre más amplio estén conformadas las palabras claves, mayor facilidad de categorizarla.'
    },
    ExpensesPage: {
      title: 'Página de Comprobaciones',
      text:
        'Permite generar comprobaciones y llevar el óptimo flujo de estados en su gasto.</br></br><li>CREADAS: Permite generar comprobaciones con sus respectivos ítems, tanto CFDI (XML) o por RECIBOS, posterior a ello puede enviar sus gastos para que inicie el proceso de validación.</li></br><li>ENVIADAS: Permite mostrar sus gastos propios previo al envió, de igual forma tiene la opción de descargar ACUSE por cada comprobación, con la finalidad de tener información de todos los ítems que ha enviado.</li></br><li>REVISADAS: Muestra la lista de gastos que fueron revisados estando en el proceso de validación y aprobación.</li></br><li>POR PAGAR: Muestra la lista de gastos que están en espera de ser pagados. </li></br><li> PAGO PARCIAL: Se reflejan aquellos gastos que tienen pagos por parcialidades (pagos incompletos).</li></br><li>PAGADAS: Muestra la lista de gastos que fueron pagados completamente (Los gastos pagados son realizados de forma externa al sistema).</li>'
    },
    pettyCashPage: {
      title: 'Página para generar caja chicas',
      text: 'Genera caja chicas, especificando la cantidad establecida y al usuario al que le pertenece dicha caja.'
    },
    requestPettyCashPage: {
      title: 'Página de Solicitud de Caja Chica',
      text:
        'Permite solicitar recursos de su caja chica y dar seguimiento a cada solicitud. En la parte superior se muestra el monto disponible en su caja chica.</br></br><li>CREADAS: Muestra las solicitudes que ha generado y aún no envía. Desde aquí puede enviarlas a validar, editarlas o eliminarlas.</li></br><li>ENVIADAS: Muestra las solicitudes que ya se encuentran en proceso de validación y aprobación.</li></br><li>COMPLETADAS: Muestra las solicitudes que ya fueron aprobadas y pagadas.</li></br><li>Seguimiento: Disponible en cualquier estatus, indica el avance de la solicitud (creada, enviada, revisada y aprobada). Si una solicitud fue rechazada se marca con una bandera roja que muestra el motivo del rechazo.</li>'
    },
    amexCardPage: {
      title: 'Página para generar tarjetas AMEX',
      text: 'Genera tarjeta AMEX, especificando la cantidad establecida y al usuario al que le pertenece dicha tarjeta.'
    },
    advancesPage: {
      title: 'Página de Anticipos',
      text:
        'Genera comprobaciones con anticipos establecidos para usuarios en específico, de esta forma dicho usuario reportará sus gastos considerando el anticipo y el proyecto al que va dirigido.'
    },
    expensesValidatePage: {
      title: 'Página de Validación de Gastos',
      text:
        '<li>VALIDAR GASTOS: Realiza el proceso de validación de gastos que se le asigne. Para dicha revisión puede consultar a detalle los datos del gasto, montos gastados, archivos adjuntos, incluso puede rechazar el item en caso que no cumpla con los lineamientos de su compañia.</li></br><li>APROBAR GASTOS: Apruebe los gastos que tiene establecido, considerando las revisiones y criterios pertinentes para su aprobación, puede consultar a detalle los datos del gasto, montos gastados, archivos adjuntos, incluso puede rechazar el item, para su posible corrección.</li>'
    },
    expensesRejectedPage: {
      title: 'Página de Gastos Rechazados',
      text:
        'Muestra todos sus gastos que el validador ha rechazado por motivos que el haya considerado, así mismo puede restablecer su item rechazado y volver a enviarla para su próxima revisión.'
    },
    ExpensesApprovedPage: {
      title: 'Página de Gastos Aprobados',
      text:
        'Permite mostrar la lista de los gastos que se han generado y que fueron aprobados con éxito.'
    },
    expensesPayablePage: {
      title: 'Página de Gastos por pagar',
      text:
        'Realice el proceso de pago de forma completa o incompleta, por cada uno de los gastos de sus empleados (El proceso de pago no está vinculado en otro sistema).'
    },
    expensesPaidPage: {
      title: 'Página de Gastos completados',
      text:
        'Muestra la lista de gastos que fueron pagados, ello permite mostrar a todos los usuarios con sus respectivos gastos que fueron cubiertos de pago en su totalidad.'
    },
    historyPage: {
      title: 'Página de Historial',
      text:
        'Revise todos sus gastos desde  enviados hasta pagados, esto le permite estar completamente informado de todos sus gastos personales que ha generado, además puede realizar filtrados desde la fecha actual hasta la anterior, y con detalles de cada gasto.'
    },
    ExpenseDetailEmployee: {
      title: 'Página de Gastos detallados por empleado',
      text: 'Permite obtener reporte de gastos de los empleados de su compañía, este reporte aplica de forma detallada mostrando los gastos de cada empleado, de igual forma si así lo desea puede aplicar el filtrado con base a datos en específicos que requiera. (Aplica descarga de reporte en formato XLS y archivos adjuntos que contenga los gastos).'
    },
    MyExpenseDetail: {
      title: 'Página de Mi reporte detallado',
      text:
        'Permite consultar el detalle de sus propios gastos; la consulta siempre se realiza sobre el usuario con el que inició sesión.</br></br><li>Filtros: Puede acotar la información por estatus, categoría, proyecto, área y rango de fechas (el periodo permitido es de hasta 30 días a partir de la fecha de inicio).</li></br><li>Con detalle: Al activarlo se muestra la información por ítem, incluyendo país, moneda, tipo de cambio, UUID y descripción de cada comprobante; al desactivarlo se muestra la información agrupada.</li></br><li>Descargar reporte: Genera el reporte en formato XLS con los resultados de la búsqueda realizada.</li>'
    },
    reportstype: {
      title: 'Página de Gastos acumulados por categoría',
      text:
        'Permite obtener el subtotal y total de los gastos aplicados por categorías, para obtener un panorama de gastos más complejos, de igual forma si lo desea puede aplicar el filtrado con base a datos en específicos que requiera. (Aplica descarga de reporte en formato XLS y archivos adjuntos que contenga los gastos).'
    },
    reportsByConceptPage: {
      title: 'Página de Gastos detallados por categoría',
      text:
        'Permite obtener la lista de gastos por categoría de forma detallada, mostrando datos en específicos del gasto, de igual forma si lo desea puede aplicar el filtrado con base a datos en específicos que requiera. (Aplica descarga de reporte en formato XLS y archivos adjuntos que contenga los gastos).'
    },
    annualExpensesReport: {
      title: 'Página de Gastos anuales por categoría',
      text: 'Permite obtener los montos totales de gastos que fueron pagados, en el lapso de un año, organizado por mes y categorías., de igual forma si lo desea puede aplicar el filtrado con base a datos en específicos que requiera. (Aplica descarga de reporte en formato XLS y archivos adjuntos que contenga los gastos).'
    },
    annualExpensesByEmployedReport: {
      title: 'Página de Gastos anuales por empleado',
      text: 'Permite obtener los montos totales por usuario, representado por mes durante un año, de igual forma si lo desea puede aplicar el filtrado con base a datos en específicos que requiera. (Aplica descarga de reporte en formato XLS y archivos adjuntos que contenga los gastos).'
    },
    reportComparativePage: {
      title: 'Página de Comparativa de gastos',
      text:
        'Permite obtener una comparativa de montos generados con filtrados específicos que ofrece el sistema, ya sea por usuario, categoría, o proyecto, tomando en cuenta dos periodos: “Mensual y Trimestral”. (Aplica descarga de reporte en formato XLS).'
    },
    SatXMLDownloadPage: {
      title: 'Página de XML pendientes para descargar del SAT',
      text:
        'Visualiza la lista de gastos que sus empleados han subido por medio de la aplicación móvil, utilizando el método de QR. Para ello deberá instalar la aplicación de electrón que le proporciona el sistema de bluespend. La descarga de la aplicación esta disponible para windows, linux y mac.'
    },
    SettingsPage: {
      title: 'Página de Ajustes',
      text:
        'Ingrese la configuración por periodo para indicar la fecha de corte para los gastos de su compañía (configuración esencial para proceso de flujo en los gastos).'
    },
    verifyEFOSPage: {
      title: 'Página de Verificar EFOS',
      text:
        'En esta pagina podras verificar todas tus facturas que se encuentre en la lista negra del sat, realiza la búsqueda mediante dos opciones: <br/> <br/> <ol> <li> BUSCAR POR RFC: Ingresa cualquier rfc con la finalidad de corroborar si es perteneciente o no a la lista negra, ello te ayudará a identificarlas antes de subir un gasto correspondiente a dicho RFC.</li><br/><li> VERIFICAR CFDIS: Permite buscar aquellos gastos con rfc que estén en la lista negra del SAT. (Gastos que fueron cargados directamente en el sistema para la compañia).</li></ol>'
    },
    rolesPage: {
      title: 'Página de Roles',
      text:
        'Como usuario SuperAdmin, tiene la opción de poder agregar Roles adicionales. Así como también agregar o quitar permisos a los roles, esto permite tener tener un amplio manejo en el sistema para cada rol.'
    },
    permissionsPage: {
      title: 'Página de Permisos',
      text:
        'Permite mostrar la lista de permisos establecidos por el sistema, así como también agregar permisos adicionales para ser utilizados.'
    },
    ExpenseItemPage: {
      title: 'Página de gastos de la comprobación',
      text:
        'Permite subir sus gastos de forma fácil y segura, puede generarlos de dos formas desde:<br/><br/><ul><li>CFDI(XML): Son gastos de xml, validados por el SAT, el sistema tiene la flexibilidad de poder cargar sus XML de forma masiva, esto quiere decir que puede arrastrar y soltar de uno a muchos, para posteriormente procesarlos, e indicarle si es un UUID repetido.</li><li>RECIBO: Son gastos que se cargan con un comprobante de recibo forzoso, para poder hacer uso de la validación, deberá llenar los campos requeridos para su dicho proceso.</li></ul> <br/> Para cada gasto insertado tiene la opción de adjuntar archivos opcionales o archivos requeridos (en caso que así lo indique su administrador). Usted puede diferenciar cuando un gasto requiere adjunto requerido de la siguiente forma: El icono de adjuntar (<i aria-hidden="true" class="v-icon material-icons theme--light" style="font-size: 20px;">attach_file</i>) se encuentra en color <span style="color: blue">AZUL</span> cuando es opcional y en color <span style="color: red">ROJO</span> cuando es requerido.'
    },
    attachFilesPage: {
      title: 'Página adjuntar archivos',
      text:
        'Permite subir sus adjuntos necesarios o requeridos para cada gasto.<br/>Los archivos permitidos a subir son en formatos:<br/><br/><ul><li>PDF</li><li>JPEG</li><li>ZIP</li></ul>Para cargar los archivos puede arrastrar y soltar, o posicionarse en el espacio en blanco de “cargar archivos, para re-direccionarlos a sus documentos.'
    },
    reportExpenseTrackingPage: {
      title: 'Página de Seguimiento de comprobaciones',
      text:
        'Permite obtener las comprobaciones de todos sus usuarios en diferentes estados que esten registrados en el sistema Bluespend.<br/><br/>Esto ayuda a dar seguimiento a cada gasto y generar filtrados de acuerdo a las consultas requeridas. Asi mismo con el botón de descargar reporte le permite generar un archivo XLS con los datos buscados.<br/><br/>En la tabla por defecto aparecerán los datos del mes actual.'
    },
    ConciliationPage: {
      title: 'Página de conciliaciones Amex',
      text:
        'Permite realizar conciliaciones bancarias de gastos Amex a los gastos registrados en el sistema Bluespend. <br/><br/> Cuenta con tres tabs donde encontraras lo siguiente: <br/><br/><ul><li><b>Por conciliar:</b> <br/>El sistema detecta coincidencias de gastos bluespend de forma automatica, para que proceda a conciliar con aquellos gastos que coincidan con el gasto amex.<br/><br/></li> <li><b>Conciliados:</b><br/> Puede ver aquellos gastos que han sido conciliado (Amex-Bluespend). </li><br/><li><b>Excluidos: </b><br/> Se muestran gastos amex y bluespend que han sido excluidos de las búsquedas</li></ul>'
    },
    ToReconcileExpensesPage: {
      title: 'Página por Conciliar',
      text:
        'En esta página puede visualizar la lista de gastos amex de acuerdo a un rango de fechas filtrados. En el resultado esperado existen dos tipos de respuestas: <br/><br/><ul><li> <span style="color:red"><b>NO ENCONTRADO:</b></span> Este resultado se debe cuando el sistema no encontró ningún gasto bluespend con el mismo monto y dentro del rango de fecha de 1 mes como máximo.<br/><br/></li><li><span style="color:green"><b>ENCONTRADO:</b></span>Cuando el sistema encuentra gastos bluespend coincidentes al gasto amex. Basado en este resultado el usuario puede excluir o conciliar el gasto equivalente al amex.<br/><br/></li><li><b>FILTRAR:</b> Puede realizar un filtro por empleados en específico.</li></ul>'
    },
    ReconciledExpensesPage: {
      title: 'Página Conciliados',
      text:
        'En esta página puede obtener la lista de gastos que han sido conciliados, cuenta con información precisa para ver los montos gastados en la tarjeta, montos que han sido conciliados, montos faltantes por conciliar y montos que hayan sido excluidos. <br/><br/> Puede utilizar el filtro para buscar gastos conciliados por empleados en especificos. (Este filtro solo aplica para usuarios ADMINISTRADORES):<br/><br/> <ul><li>Filtro “Gastos conciliados”: Permite mostrar la lista de gastos conciliados. <br/><br/><li>Filtro “Gastos rechazados” permite mostrar la lista de gastos que estan pendientes por conciliar.<l/i></li></ul>'
    },
    ExcludedExpensesPage: {
      title: 'Página por Excluidos',
      text:
        'La página de gastos excluidos permite mostrarle la lista de gastos que fueron quitados de la lista de por conciliar, todos los gastos que estan excluidos no volverán aparecer en la busqueda para coincidir con un gasto bluespend. <br/><br/>Se puede filtrar la busqueda por usuarios en específico de su compañía, en este caso el sistema mostrará datos del unico usuario.'
    },
    MissingExpensesPage: {
      title: 'Página Faltantes',
      text:
        'La página de gastos rechazados le permite devolver la lista de gastos que no han encontrado coincidencias con gastos bluespend, por lo mismo puede generar la cargar de dicho gasto en el sistema bluespend. <br/><br/> La opción <button type="button" class="v-btn v-btn--icon v-btn--outline v-btn--depressed v-btn--small theme--light info--text"><div class="v-btn__content"><i aria-hidden="true" class="v-icon material-icons theme--light" style="font-size: 16px;">add</i></div></button><br/> Te permite subir el gasto, ya sea un gasto fiscal o un gasto no fiscal, al dar clic le permite seleccionar el tipo y posterior subir el archivo solicitado.'
    },
    cashierpage: {
      title: 'Página Representante',
      text: 'Para registrar un representante debe dar clic en la opción "Agregar representante" puede registrar de uno a muchos representantes con rol "usuario", estos representantes serán los encargados de poder realizar reservaciones a otros usuarios de la compañía. </br> Un representante puede estar relacionado aun área en especifico, o de forma global al sistema.'
    },
    generalSearchPage: {
      title: 'Página búsqueda general',
      text:
        'Esta página obtiene como punto de partida la identificación y búsqueda de un id o folio en todo el sistema Bluespend, logrando un mejor posicionamiento a los datos y a su vez una mayor organización. '
    },
    GeneralConfig: {
      title: 'Página configuración general',
      text:
        'En esta sección encontraras todas las opciones que se necesita para poder configurar el sistema bluespend. Registra Áreas, Proyectos, Palabras claves, etc.'
    },
    viaticRequestPage: {
      title: 'Página solicitud de gastos',
      text:
        'Genera diversas solicitudes de gastos, puedes registrar una solicitud indicando si es un viaje, o si vas a requerir  un vehículo de tu compañía. Cada solicitud es enviado y validador por los superiores para dar la aprobación. Al crear una solicitud vas a poder agregar de uno a muchas categorías según las necesidades. Debes seleccionar si la solicitud que se esta pidiendo es de tipo: <br/><br/><ul><li>Caja chica/Tarjeta AMEX: Cuando se tiene relacionado una caja con montos positivos para poder usarlo en gastos.</li><li>Comprobación de anticipo: Cuando requieres que la compañía te proporcione un monto estimado de los gastos a surgir.</li><li>Reembolso: Opción por default que proporciona el sistema, cuando los gastos que se generen en la solicitud son reembolsados por la compañía en un determinado momento.</li></ul><br/> Para cada solicitud se puede visualizar el progreso e las pestañas EN VALIDACIÓN, APROBADAS, RECHAZADAS.'
    },
    reservationsPage: {
      title: 'Página reservación por solicitud',
      text:
        'Puedes crear solicitudes de gastos para aquellos usuarios de su compañía. Estas reservas son asignados a usuarios que presenten gastos durante un viaje determinado. Para cada solicitud a crear debes seleccionar si la solicitud que se esta pidiendo es de tipo: <br/><br/><ul><li>Caja chica/Tarjeta AMEX: Cuando se tiene relacionado una caja con montos positivos para poder usarlo en gastos.</li><li>Comprobación de anticipo: Cuando requieres que la compañía  proporcione un monto estimado de los gastos a surgir.</li><li>Reembolso: Opción por default que proporciona el sistema, cuando los gastos que se generen en la solicitud son reembolsados por la compañía en un determinado momento.</li></ul><br/> Para cada solicitud se puede ver el registro de estatus. Los usuarios responsables de generar solicitudes pueden cargar los gastos que generen los usuarios, de igual manera el mismo usuario que se le asigne la solicitud lo puede realizar.'
    },
    reservationsChecksPage: {
      title: 'Página reservación de comprobaciones',
      text:
        'Puedes generar reservas de gastos para otros usuarios de la compañia. Para registrar una nueva comprobación se debe seleccionar el periodo que aplicarán los gastos, proyecto correspondiente, y el usuario al que se le asignará el gasto. una vez creado la reserva, el usuario asignad puede cargar sus lineas de gastos.'
    },
    Vehicles: {
      title: 'Página vehículos',
      text:
        'Registra el catálogo de vehículos existentes en la compañía. Los registros de dichos vehículos servirán para poder relacionar Solicitud de gastos con un vehículo. </br> Al ingresar un nuevo vehículo debe registrar el tipo, nombre, serie, modelo y las placas del auto. Además de una información adicional en descripción.'
    },
    GeneralReports: {
      title: 'Página Reportes',
      text:
        'Se muestra una selección de múltiples reportes con una descripción general. Cada reporte proporciona datos diferentes según las necesidades requeridas. </br></br> Puedes realizar búsquedas muy especificas de gastos con usuarios en reporte de "Gastos detallados por empleado", o si gusta llevar un seguimiento de todos los gastos emitidos puede consultar el reporte de "Seguimiento de comprobaciones", estos por mencionar los mas relevantes. </br></br>  Para ver cada reporte debe dar clic en cada uno de ellos que lo redirigirá a la tabla de datos para filtrar los datos requeridos.'
    },
    HelpCenter: {
      title: 'Página Centro de ayuda',
      text:
        'Levanta las incidencias presentadas en el sistema bluespend, recuerda que estamos para ayudarte, y cada comentario tuyo nos servirá para seguir mejorando. </br></br> Para realizar un reporte debes dar clic en "REPORTAR INCIDENCIA", de ahí redirigirá al sistema de tickets en donde puedes realizar el reporte indicando el detalle de incidencias.'
    },
    FuelReport: {
      title: 'Página de reporte de combustible',
      text:
        'Se muestran los datos de vehículos que hayan realizado recorridos de viaje y estén relacionado a una solicitud, saber cuantos kilómetros recorrieron y los litros de gasolina que consumieron.'
    },
    advancesRequest: {
      title: 'Solicitud de anticipos de gastos',
      text: 'Lleva el seguimiento de las solicitudes de anticipos y el presupuesto por categoria de gastos requeridos por los usuarios'
    }
  },
  expenseRejected: {
    goRejectedExpenses: 'Ir a Gastos Rechazados',
    goChecks: 'Ir a Comprobaciones',
    addExpensesRejectedMessage:
      'Se ha agregado gasto rechazado a comprobación, para realizar la modificación debe "Ir a Comprobaciones" para volver a enviar su gasto.'
  },
  cashier: {
    name: 'Representante',
    addCashier: 'Agregar representante',
    selectionUserCashier: 'Seleccione el usuario representante*',
    areaCashier: 'Seleccione un área (opcional)',
    delete: 'Eliminar representante'
  },
  generalSearch: {
    name: 'Búsqueda general',
    checkType: 'Tipo de comprobación',
    noResults: 'No se encontraron resultados relacionados',
    request: 'Descargar solicitud',
    check: 'No. de comprobación',
    uuidNumber: 'No. UUID (Dato registrado en el CFDI)'
  },
  vehicles: {
    vehicles: 'Vehículos',
    type: 'Tipo',
    name: 'Nombre',
    description: 'Descripción',
    serie: 'Serie',
    model: 'Modelo',
    licensePlate: 'Placas',
    titleAdd: 'Agregar vehículo',
    titleEdit: 'Editar vehículo',
    titleDelete: 'Eliminar vehículo',
    save: 'Guardar',
    cancel: 'Cancelar',
    required: 'El campo es requerido',
    deleteQuestion: '¿Está seguro que desea eliminar este vehículo?',
    vehicle: 'Vehículo',
    report: {
      name: 'Reporte de combustible',
      description: 'Permite obtener datos de vehículos que hayan realizado recorridos de viaje y estén relacionado a una solicitud, saber cuantos kilómetros recorrieron y los litros de gasolina que consumieron.',
      application: 'Solicitud',
      vehicle: 'Vehículo',
      licensePlate: 'Placa',
      project: 'Proyecto',
      assignedTo: 'Asignado a',
      dateAssigned: 'Fecha asignado',
      KmTraveled: 'Km recorrido',
      fuel: 'Combustible',
      allVehicles: 'Todos los vehículos',
      perVehicle: 'Por vehículo'
    }
  },
  documentsDownload: {
    title: 'Descarga de documentos',
    acknowledgment: 'Acuse Comprobación',
    acknowledgmentXLS: 'Acuse Detallado(XLS)',
    expenseRequestPDF: 'Solicitud de Gastos(PDF)',
    expenseRequestXLS: 'Solicitud de Gastos(XLS)',
    zipFiles: 'Descarga de Archivos(ZIP)'
  },
  vendors: {
    messageNewVendor: 'Se agregara como un nuevo proveedor, al momento de guardar la solicitud'
  },
  branches: {
    allBranches: 'Todas las sucursales',
    selectedMultiple: 'Selecciono múltiples sucursales',
  },
  representatives: {
    title: 'Representantes',
    representative: 'Representante',
    subtitle: 'Representantes de la compañía por usuario',
    add: 'Agregar representante',
    delete: 'Eliminar representante',
  },
    request: {
    title: 'Solicitud',
    subtitle: 'Historial de solicitudes de gastos',
    validate: 'Validar solicitud',
    validatePettyCash: 'Validar solicitud caja chica',
    toValidate: 'Por validar',
    toApprove: 'Por aprobar',
    validated: 'Validadas',
  },
  config: {
    title: 'Configuración',
    approvalFlows: 'Flujos de aprobación',
  },
  support: {
    title: 'Soporte',
  },
  file: {
    errorViewDownload:'Use el botón descargar si no puede ver el PDF'
  }
}



// WEBPACK FOOTER //
// ./src/lang/es.js